var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMylogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 1024 1024",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#ffa900"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.3 791.2V546.1h64.9v245.1h-64.9ZM496.8 791.8V275.3h64.8v516.5h-64.8ZM219.8 210.5h618.8v64.8H219.8v-64.8ZM655.4 373.6l173.4 173.3-45.8 45.9-173.4-173.4 45.8-45.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400 373.6 173.4 173.3-45.9 45.9-173.3-173.4 45.8-45.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.7 373.6 226.3 546.9l45.9 45.9 173.3-173.4-45.8-45.8ZM655.3 373.6 482 546.9l45.8 45.9 173.4-173.4-45.9-45.8ZM764 792.2V547h64.8v245.2H764Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m794.4 813.4 34.4-21.2-39.8-3.8 5.4 25ZM620.9 394.9l34.4-21.3-27.7 29.9-6.7-8.6ZM527.2 813l34.4-21.2-34.4-2V813ZM256.7 812.6l34.5-21.4-36.9-16.9 2.4 38.3ZM365.3 394.9l34.4-21.3-23 37.4-11.4-16.1ZM185.4 231.8l34.4-21.3 6.7 31-41.1-9.7ZM804.2 296.6l34.4-21.3-38.8-5.5 4.4 26.8Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m794.3 568.3 34.5-21.3v245.2l-34.5 21.3V568.3ZM256.7 595.1l34.5-21.3v217.4l-34.5 21.4V595Z",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m620.9 394.9 173.5 173.4 34.4-21.3-173.5-173.4-34.4 21.3Z",
    fill: "#fff",
    fillOpacity: 0.4,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "m527.2 580.3 34.5-21.4v232.9L527.1 813V580.3ZM527.2 296.6h34.4v157.6l-34.4 34.7V296.6Z",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m627.5 493-6.6-6.6-93.7 93.9 34.5-21.4M372 493l-6.6-6.6-108.7 108.7 34.5-21.3",
    fillOpacity: 0.8,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "m365.5 394.8 34.5-21.2 62.4 62.6v55.5l-97-97Z",
    fill: "#fff",
    fillOpacity: 0.4,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.2 231.8v64.8l34.4-21.3v-64.8l-34.4 21.3Z",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m185.4 231.8 34.4-21.3h618.8l-34.4 21.3H185.4Z",
    fill: "#fff",
    fillOpacity: 0.4,
    opacity: 0.6
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffa900",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.9 812.6V567.4h64.8v245.2H192ZM462.4 813V296.7h64.8v516.5h-64.8ZM185.4 231.8h618.8v64.8H185.4v-64.8ZM621 394.9l173.4 173.4-45.9 45.8-173.4-173.4L621 395Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m365.6 394.9 173.3 173.4-45.8 45.8-173.4-173.4 45.9-45.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.3 394.9 191.9 568.3l45.8 45.8 173.4-173.4-45.8-45.8ZM620.9 394.9 447.5 568.3l45.9 45.8 173.3-173.4L621 395ZM729.5 813.5V568.3h64.9v245.2h-64.9Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMylogo);
export default __webpack_public_path__ + "static/media/mylogo.b69a217eb0c2da2b3ba62d28330e0e80.svg";
export { ForwardRef as ReactComponent };